import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { Button, Form, Alert } from 'react-bootstrap';
import { BsCalendar2WeekFill, BsCheckCircle } from "react-icons/bs";
import { CiEdit } from "react-icons/ci";
import './EditHoliday.css';

export default function EditPublicHoliday() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [holiday, setHoliday] = useState({ holidayName: '', date: '', payRate: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    const fetchHoliday = async () => {
      try {
        const response = await axios.get(`https://backend.ems.hiradentallab.com/api/holidays/${id}`);
        setHoliday(response.data);
      } catch (error) {
        console.error('Error fetching holiday:', error);
        setError('Error fetching holiday data');
      } finally {
        setLoading(false);
      }
    };
    fetchHoliday();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`https://backend.ems.hiradentallab.com/api/holidays/${id}`, holiday);
      setShowAlert(true);
      setError(null);
      setTimeout(() => {
        navigate('/public-holidays');
      }, 2000);
    } catch (error) {
      console.error('Error updating holiday:', error);
      setError('Error updating holiday data');
      setShowAlert(false);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <Alert variant="danger">{error}</Alert>;

  return (
    <div className="container-fluid">
      <h1 className='holiday-title'>
        <BsCalendar2WeekFill style={{ marginRight: '5px' }} />
        Public Holidays
      </h1>
      <hr />
      <h1 className='holiday-subtitle'>
        <CiEdit style={{ marginRight: '5px' }} />
        Edit Holiday
      </h1>
      <hr />
      <div className='edit-holiday-content'>
        {showAlert && <Alert variant="success">Holiday updated successfully!</Alert>}
        <Form onSubmit={handleSubmit} className="holiday-form">
          <div className="form-row">
            <Form.Group controlId="holidayName" className="form-group">
              <Form.Label>Holiday Name</Form.Label>
              <Form.Control
                type="text"
                value={holiday.holidayName}
                onChange={(e) => setHoliday({ ...holiday, holidayName: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group controlId="date" className="form-group">
              <Form.Label>Date</Form.Label>
              <Form.Control
                type="date"
                value={holiday.date ? new Date(holiday.date).toISOString().split('T')[0] : ''}
                onChange={(e) => setHoliday({ ...holiday, date: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group controlId="payRate" className="form-group">
              <Form.Label>Pay Rate</Form.Label>
              <Form.Control
                type="number"
                value={holiday.payRate}
                onChange={(e) => setHoliday({ ...holiday, payRate: e.target.value })}
                required
              />
            </Form.Group>
          </div>
          <div className="button-container">
            <Button variant="success" type="submit" className="submit-button">
              <BsCheckCircle style={{ marginRight: '5px' }} />
              Update Holiday
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
}
